import { emptyBookingDraft, getBookingDraft, saveBookingDraft } from '../data/ceramic-booking'
import type { CeramicPackage } from '../data/protection-catalog'
import { shouldRotateBookingIdentity } from './book-flow'
import {
  persistSelectedProtection,
  toSelectedProtection,
  type ProtectionStorage,
} from './selected-protection'

export function commitSelectedProtection(
  item: CeramicPackage,
  storage?: ProtectionStorage | null,
  options?: { newBookingIntent?: boolean },
) {
  const selection = toSelectedProtection(item)
  persistSelectedProtection(selection, storage)
  const draft = getBookingDraft()
  const newBookingIntent = options?.newBookingIntent === true
  const rotate = shouldRotateBookingIdentity({
    publicReference: draft.publicReference,
    existingPackageId: draft.packageId,
    nextPackageId: selection.id,
    newBookingIntent,
  })

  if (newBookingIntent || rotate) {
    saveBookingDraft({
      ...emptyBookingDraft,
      servicePath: 'ceramic',
      packageId: selection.id,
      startingPriceCents: selection.startingPriceCents,
      addOns: [],
      addOnsCommitted: false,
      noAdditionalProtection: false,
    })
  } else {
    saveBookingDraft({
      ...draft,
      servicePath: 'ceramic',
      packageId: selection.id,
      startingPriceCents: selection.startingPriceCents,
    })
  }
  return selection
}
